import { Cpf } from 'models/domain/cpf.domain';
import * as yup from 'yup';

export const forgotPasswordSchema = yup.object({
    cpf: yup.string()
        .required('CPF é obrigatório.')
        .length(14, 'Preencha com o seu CPF.')
        .test('check cpf validity', 'CPF em formato inválido', (cpf) => {
            try {
                Cpf.fromString(cpf!);
                return true
            } catch (err) {
                return false;
            }
        }),
})

export type ForgotPasswordFormData = {
    cpf: string;
}

export const resetPasswordSchema = yup.object({
    newPassword: yup.string()
        .required('Senha é obrigatória.')
        .min(8, 'É obrigatório no mínimo 8 caracteres.')
        .matches(/[a-z]/g, 'Senha deve possuir 1 letra minúscula.')
        .matches(/[A-Z]/g, 'Senha deve possuir 1 letra maiúscula.')
        .matches(/\d/g, 'Senha deve possuir 1 dígito.'),
    newPasswordConfirmation: yup.string()
        .required('Confirmação de senha é obrigatória.')
        .min(8, { message: 'É obrigatório no mínimo 8 caracteres.' })
        .oneOf([yup.ref('newPassword')], 'Senhas devem ser iguais')
})

export type ResetPasswordFormData = {
    newPassword: string;
    newPasswordConfirmation: string;
}